module.exports = __webpack_public_path__ + "static/media/evening-snack1-1.fb593d13.jpg";